const login = [
  {
    path: "/login",
    name: "Login",
    hidden: true,
    meta: { title: '登录' },
    component: () => import("@/views/newLogin/index")
  },
  {
    path: '/userRegister',
    component: () => import('@/views/newLogin/userRegister'),
    meta: { title: '注册' },
    hidden: true
  },
  {
    path: '/resetKeyWord',
    component: () => import('@/views/newLogin/resetKeyWord'),
    meta: { title: '重置密码' },
    hidden: true
  },
  {
    path: '/qrCodeLogin',
    component: () => import('@/views/newLogin/qrCodeLogin'),
    meta: { title: '二维码登录' },
    hidden: true
  },
  {
    path: '/confirmPassword',
    component: () => import('@/views/newLogin/confirmPassword'),
    meta: { title: '确认重置密码' },
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/newLogin/authRedirect.vue'),
    hidden: true
  }
]

export default login



// WEBPACK FOOTER //
// ./src/router/login/index.js